import { INTERAX_COLORS } from '../../../../../../constants/colors'
import type { TeamPerformanceData } from './types'

/**
 * Constants for Team Information Shares Line Chart visualization
 */

/**
 * Team colors mapped to design system colors
 */
export const TEAM_COLORS = {
  TEAM_1: INTERAX_COLORS.sun, // #FFAB40
  TEAM_2: INTERAX_COLORS.thunderGrey // #78909C
} as const

/**
 * Axis and grid colors
 */
export const AXIS_COLOR = INTERAX_COLORS.thunderGrey

/**
 * Chart configuration constants
 */
export const CHART_CONFIG = {
  margin: {
    top: 10,
    right: 30,
    left: 20,
    bottom: 5
  },
  yAxisDomain: [0, 5] as [number, number],
  yAxisTicks: [0, 1, 2, 3, 4, 5],
  yAxisWidth: 25,
  lineStrokeWidth: 3,
  activeDotRadius: 6,
  activeDotStrokeWidth: 2
} as const

/**
 * Legend configuration
 */
export const LEGEND_CONFIG = {
  iconSize: 12, // w-3 h-3 = 12px
  iconBorderRadius: 3, // rounded-[3px] = 3px
  gap: 24 // gap-6 = 24px
} as const

/**
 * Team 1 legend icon gradient
 */
export const TEAM_1_GRADIENT = 'linear-gradient(360deg, #FFD196 0%, #FFAB40 23.08%, #FFFFFF 100%)'

/**
 * Team 1 legend icon shadow
 */
export const TEAM_1_SHADOW = '0px 0px 10px rgba(0, 0, 0, 0.5), 0px 0px 20px rgba(255, 171, 64, 0.4)'

/**
 * Legend border color
 */
export const LEGEND_BORDER_COLOR = 'rgba(255, 255, 255, 0.25)'

/**
 * Tooltip configuration
 */
export const TOOLTIP_CONFIG = {
  decimalPlaces: 1
} as const

/**
 * Default mock data for development
 */
export const DEFAULT_MOCK_DATA: TeamPerformanceData[] = [
  { period: 1, team1Shares: 0.5, team2Shares: 1.7 },
  { period: 2, team1Shares: 0.7, team2Shares: 1.7 },
  { period: 3, team1Shares: 1.2, team2Shares: 1.0 },
  { period: 4, team1Shares: 1.8, team2Shares: 1.5 },
  { period: 5, team1Shares: 2.3, team2Shares: 1.0 },
  { period: 6, team1Shares: 2.6, team2Shares: 1.7 },
  { period: 7, team1Shares: 2.4, team2Shares: 1.5 },
  { period: 8, team1Shares: 1.7, team2Shares: 1.0 },
  { period: 9, team1Shares: 1.6, team2Shares: 0.8 },
  { period: 10, team1Shares: 1.7, team2Shares: 1.2 },
  { period: 11, team1Shares: 2.0, team2Shares: 1.8 },
  { period: 12, team1Shares: 2.3, team2Shares: 2.8 },
  { period: 13, team1Shares: 2.6, team2Shares: 3.5 }
]
